import i18n from '../i18n/i18n'
import {getCookie} from '../utils/common'
import urls from '../utils/baseUrl'

function helpCenterPath() {
  const lang = getCookie('language')
  if (lang == 'zh-TC') return 'https://support.superex.com/hc/zh-hk'
  if (lang == 'ko') return 'https://support.superex.com/hc/ko'
  return 'https://support.superex.com/hc/en-001'
}

// Vue 2 + JS 风格，不使用 Nuxt Composition API
// 返回站点导航相关的静态数据（按当前语言翻译）
export function useSiteNav() {
  const moreNavGroups = [
    {
      title: i18n.t('more_panel.group_activities'),
      items: [
        {
          icon: 'icon-a-1USD',
          iconType: true,
          title: i18n.t('nav.5.0'),
          path: '/advanced/1USD',
          type: 1,
        },
        {
          icon: 'icon-a-EventCenter',
          iconType: true,
          title: i18n.t('nav.6.0'),
          path: '/events',
          type: 1,
        },
        {
          icon: 'ueicon-yao-qing-hao-you',
          title: i18n.t('400236'),
          path: '/userCenter/commission',
          type: 1,
        },
        {
          icon: 'ueicon-mang-he-jiang-li',
          title: i18n.t('more_panel.mang_he_jiang_li_title'),
          path: '/activity/lottery',
          type: 1,
        },
        {
          icon: 'icon-SPACE',
          iconType: true,
          title: i18n.t('nav.9.0'),
          path: '',
          type: 5,
        },
      ],
    },
    {
      title: i18n.t('more_panel.group_ecosystem'),
      items: [
        {
          icon: 'ueicon-dao-wang-luo',
          title: i18n.t('400234'),
          path: '/dao',
          type: 1,
        },
        {
          icon: 'ueicon-et-zhuan-qu',
          title: i18n.t('more_panel.et_zone_title'),
          path: '/advanced/et',
          type: 1,
        },
        {
          icon: 'ueicon-btc-startup',
          title: i18n.t('more_panel.btc_startup_title'),
          path: '/advanced/markets?btcStartup=1',
          type: 1,
        },
        {
          icon: 'ueicon-bang-zhu-zhong-xin',
          title: i18n.t('400237'),
          path: helpCenterPath(),
          type: 2,
        },
      ],
    },
    {
      title: i18n.t('more_panel.group_business'),
      items: [
        {
          icon: 'icon-dailishang',
          iconType: true,
          title: i18n.t('nav.7.0'),
          path: '',
          type: 4,
        },
        {
          icon: 'icon-a-erweima41',
          iconType: true,
          title: i18n.t('400250'),
          path: `${urls.threePartyUrl}/`,
          type: 2,
        },
        {
          icon: 'icon-xianhuoziyouqu',
          iconType: true,
          title: i18n.t('nav.8.0'),
          path: '/freeMarket/listingToken',
          type: 1,
        },
      ],
    },
  ]

  const moreNavList = moreNavGroups.reduce((list, group) => list.concat(group.items), [])

  // 顶部导航栏
  const navList = [
    {
      title: i18n.t('nav.0.0'),
      subnav: [
        {
          icon: 'ueicon-p2p',
          title: i18n.t('nav.0.1.0.title'),
          subtitle: i18n.t('nav.0.1.0.subtitle'),
          path: `/`,
          type: 3,
        },
        {
          icon: 'ueicon-di-san-fang',
          title: i18n.t('400294'),
          subtitle: i18n.t('nav.0.1.1.subtitle'),
          path: `/thirdParty`,
          type: 3,
        },
      ],
    },
    {
      title: i18n.t('nav.1.0'),
      subnav: [
        {
          icon: 'ueicon-hang-qing',
          title: i18n.t('nav.1.1.0.title'),
          subtitle: i18n.t('nav.1.1.0.subtitle'),
          path: '/advanced/markets',
          type: 1,
        },
        {
          icon: 'ueicon-shu-ju',
          title: i18n.t('nav.1.1.1.title'),
          subtitle: i18n.t('nav.1.1.1.subtitle'),
          path: '/advanced/screener',
          type: 1,
        },
      ],
    },
    {
      title: i18n.t('nav.2.0'),
      subnav: [
        {
          icon: 'ueicon-xian-huo',
          title: i18n.t('nav.2.1.0.title'),
          subtitle: i18n.t('nav.2.1.0.subtitle'),
          path: '/trade/BTC_USDT',
          type: 1,
        },
        {
          icon: 'ueicon-xian-huo-wang-ge',
          title: i18n.t('nav.2.1.1.title'),
          subtitle: i18n.t('nav.2.1.1.subtitle'),
          path: '/trade/BTC_USDT',
          tradeGroud: 'tradeGroud',
          type: 1,
        },
        {
          icon: 'icon-a-Frame1171276415',
          title: i18n.t('nav.2.1.2.title'),
          subtitle: i18n.t('nav.2.1.2.subtitle'),
          path: '/trade/TSLA_USDT?isMT5=1',
          tradeStock: 'tradeStock',
          type: 1,
          iconType: true,
        },
      ],
    },
    {
      title: i18n.t('nav.3.0'),
      subnav: [
        {
          icon: 'ueicon-he-yue',
          title: i18n.t('nav.3.1.0.title'),
          subtitle: i18n.t('nav.3.1.0.subtitle'),
          path: '/contract/BTC_USDT',
          type: 1,
        },
        {
          icon: 'ueicon-he-yue-gen-dan',
          title: i18n.t('nav.3.1.1.title'),
          subtitle: i18n.t('nav.3.1.1.subtitle'),
          path: '/advanced/copy-trading',
          type: 1,
        },
      ],
    },
    {
      title: i18n.t('nav.4.0'),
      subnav: [
        {
          icon: 'ueicon-li-cai',
          title: i18n.t('nav.4.1.0.title'),
          subtitle: i18n.t('nav.4.1.0.subtitle'),
          path: '/sortMoney/sortMoneyIndex',
          type: 1,
        },
        {
          icon: 'ueicon-liang-hua-ji-jin',
          title: i18n.t('nav.4.1.1.title'),
          subtitle: i18n.t('nav.4.1.1.subtitle'),
          path: '/advanced/quantitativeFunds',
          type: 1,
        },
        {
          icon: 'ueicon-super-start',
          title: i18n.t('nav.4.1.2.title'),
          subtitle: i18n.t('nav.4.1.2.subtitle'),
          path: '/activity/SuperStart',
          type: 1,
        },
      ],
    },
    {title: i18n.t('400094'), isMore: true},
  ]

  return {moreNavList, moreNavGroups, navList}
}
